/** Expedientes creados desde esta fecha requieren campos de catálogo al editar. */
export const CATALOGO_CAMPOS_CUTOFF = new Date('2026-06-02T00:00:00.000Z');

export const TIPO_PROYECTO_OPTIONS = [
  { value: 'VIVIENDA UNIFAMILIAR', label: 'Vivienda unifamiliar' },
  { value: 'VIVIENDA MULTIFAMILIAR', label: 'Vivienda multifamiliar' },
  { value: 'LOCAL COMERCIAL', label: 'Local comercial' },
  { value: 'OTROS', label: 'Otros' },
];

export const DEPARTAMENTOS_PERU = [
  'LIMA',
  'CALLAO',
  'AREQUIPA',
  'LA LIBERTAD',
  'LAMBAYEQUE',
  'PIURA',
  'CUSCO',
  'JUNIN',
  'ICA',
  'ANCASH',
  'LORETO',
  'PUNO',
  'CAJAMARCA',
  'HUANUCO',
  'AYACUCHO',
  'UCAYALI',
  'AMAZONAS',
  'TACNA',
  'MOQUEGUA',
  'PASCO',
  'TUMBES',
  'HUANCAVELICA',
  'APURIMAC',
  'MADRE DE DIOS',
  'SAN MARTIN',
];

const ENUM_TO_LABEL = {
  VIVIENDA_UNIFAMILIAR: 'VIVIENDA UNIFAMILIAR',
  VIVIENDA_MULTIFAMILIAR: 'VIVIENDA MULTIFAMILIAR',
  LOCAL_COMERCIAL: 'LOCAL COMERCIAL',
  OTROS: 'OTROS',
};

export const tipoProyectoFromApi = (raw) => {
  if (!raw) return '';
  return ENUM_TO_LABEL[raw] || raw;
};

export const requiereCatalogoCampos = (createdAt, { isCreate = false } = {}) => {
  if (isCreate) return true;
  if (!createdAt) return false;
  const d = createdAt instanceof Date ? createdAt : new Date(createdAt);
  if (Number.isNaN(d.getTime())) return false;
  return d >= CATALOGO_CAMPOS_CUTOFF;
};

export const emptyCatalogoFields = () => ({
  sector: '',
  distrito: '',
  departamento: 'LIMA',
  tipoProyecto: '',
  tipoProyectoOtro: '',
  metrosCuadrados: '',
});

export const validateCatalogoFields = (data, { required = true } = {}) => {
  const sector = String(data.sector || '').trim();
  const distrito = String(data.distrito || '').trim();
  const departamento = String(data.departamento || '').trim();
  const tipoProyecto = String(data.tipoProyecto || '').trim();
  const tipoProyectoOtro = String(data.tipoProyectoOtro || '').trim();
  const metrosRaw = data.metrosCuadrados;

  const anyFilled = sector || distrito || departamento || tipoProyecto || tipoProyectoOtro
    || (metrosRaw !== '' && metrosRaw != null);

  if (!required && !anyFilled) return null;

  if (required || anyFilled) {
    if (!sector) return 'Sector es obligatorio';
    if (!distrito) return 'Distrito es obligatorio';
    if (!departamento) return 'Departamento es obligatorio';
    if (!tipoProyecto) return 'Tipo de proyecto es obligatorio';
    if (tipoProyecto === 'OTROS' && !tipoProyectoOtro) {
      return 'Especifique el tipo de proyecto';
    }
    if (metrosRaw === '' || metrosRaw == null) return 'Metros cuadrados es obligatorio';
    const n = Number(metrosRaw);
    if (!Number.isFinite(n) || n < 0) return 'Metros cuadrados debe ser ≥ 0';
  }
  return null;
};

export const catalogoPayloadFromForm = (formData) => ({
  sector: String(formData.sector || '').trim().toUpperCase(),
  distrito: String(formData.distrito || '').trim().toUpperCase(),
  departamento: String(formData.departamento || '').trim().toUpperCase() || null,
  tipoProyecto: formData.tipoProyecto || null,
  tipoProyectoOtro: formData.tipoProyecto === 'OTROS'
    ? String(formData.tipoProyectoOtro || '').trim()
    : null,
  metrosCuadrados: formData.metrosCuadrados !== '' && formData.metrosCuadrados != null
    ? parseFloat(formData.metrosCuadrados)
    : null,
});
